import type { ChapterItem } from '@app/_proto/Protos/chapters';
import type { NovelItem } from '@app/_proto/Protos/novels';
import useRouteFrom from '@app/analytics/hooks/useRouteFrom';
import { ChapterEvents } from '@app/domains/chapter/analytics/posthog/events';
import { chapterAnalyticsFactory } from '@app/domains/chapter/analytics/posthog/handlers';
import { type ReactNode, useEffect } from 'react';

type Props = {
    novel?: NovelItem;
    chapter?: ChapterItem;
    type: string;
    children?: ReactNode;
};

export default function LockLogger({ novel, chapter, type, children }: Props) {
    const from = useRouteFrom();

    useEffect(() => {
        if (novel && chapter && type) {
            chapterAnalyticsFactory(ChapterEvents.ViewLockedScreen)({
                novel,
                chapter,
                type,
                from: from ?? 'Etc',
            });
        }
    }, [novel, chapter, type, from]);
    return <>{children}</>;
}
